import { render, staticRenderFns } from "./label-sconti-listino.vue?vue&type=template&id=a8be3c0a&"
import script from "./label-sconti-listino.vue.ts?vue&type=script&lang=ts&"
export * from "./label-sconti-listino.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports